import { render, staticRenderFns } from "./customerInformation.vue?vue&type=template&id=4a7d91e4&scoped=true"
import script from "./customerInformation.vue?vue&type=script&lang=js"
export * from "./customerInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d91e4",
  null
  
)

export default component.exports